import React from 'react';
import {Link} from '@mui/material';

// Reviews created before the Risk Profiling feature shipped (ON-7751, Sep 2025) have
// no contacts or risk profiles
export const RISK_PROFILING_LAUNCH_DATE = new Date('2025-09-01T00:00:00Z');

export const RISK_SUPPORT_URL = 'https://saltus.freshdesk.com/support/home';

export const RISK_UNAVAILABLE_LEGACY_REVIEW_MESSAGE =
  'As this review predates the introduction of the Risk Profiling feature, this section is unavailable.';

// Mark's copy, split either side of the support link. Keep the leading/trailing spaces
// when reworking it — the three parts are concatenated straight into the sentence.
export const RISK_UNAVAILABLE_NO_CONTACTS_MESSAGE_START =
  'Risk profiling is unavailable for this review because no eligible contacts were found. ' +
  'It is required that the contact status in Curo be set to "Client" or "Prospect" in order ' +
  'to use the risk profiling section. Please confirm that the contact status in Curo has been ' +
  'set correctly, before reloading this page. If the problem continues, please ';

export const RISK_UNAVAILABLE_NO_CONTACTS_LINK_TEXT = 'raise a ticket';

export const RISK_UNAVAILABLE_NO_CONTACTS_MESSAGE_END = ' with the Product Team.';

export const isLegacyRiskReview = (dateCreated?: string | null): boolean =>
  !!dateCreated && new Date(dateCreated) < RISK_PROFILING_LAUNCH_DATE;

export const RiskUnavailableMessage: React.FC<{dateCreated?: string | null}> = ({
  dateCreated,
}) => {
  if (isLegacyRiskReview(dateCreated)) {
    return <>{RISK_UNAVAILABLE_LEGACY_REVIEW_MESSAGE}</>;
  }

  return (
    <>
      {RISK_UNAVAILABLE_NO_CONTACTS_MESSAGE_START}
      <Link href={RISK_SUPPORT_URL} target="_blank" rel="noreferrer">
        {RISK_UNAVAILABLE_NO_CONTACTS_LINK_TEXT}
      </Link>
      {RISK_UNAVAILABLE_NO_CONTACTS_MESSAGE_END}
    </>
  );
};
